module.exports = __webpack_public_path__ + "static/media/messanger.dbd99f8c.png";